export {default as Laptop} from './laptop.png'
export {default as BookmarkTabs} from './bookmark-tabs.png'
export {default as Briefcase} from './briefcase.png'
export {default as Microscope} from './microscope.png'
export {default as Download} from './download.svg'